import { createClient } from "contentful";

const payload = {
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
};

const client = createClient(payload);

export default client;
